import type { IMetaDataFormHook } from '../../../app/electoral-divisions/state/utils';
import type { ICountryStateByID, ICountryStates, IWardsInCountryState } from '../../../interface/state/ICountryState';
import { countryStateType } from '../../types';
import { createAPI, deleteByIdAPI, getAPI, getByIdAPI, getByNameAPI, getFetchAPI, updateAPI, updateByIdAPI } from '../api-utils';

export const create = createAPI<undefined, ICountryStateCreateUpdate>({
	actionType: countryStateType.create,
	url: '/api/v1/State',
});

export const get = getAPI<ICountryStates>({
	actionType: countryStateType.get,
	url: '/api/v1/State',
	type: 'core',
});

export const getWards = getFetchAPI<
	IWardsInCountryState,
	{
		stateIds: number[];
	}
>({
	actionType: countryStateType.getWards,
	url: '/api/v1/State/getWardsInState',
});

export const getByID = getByIdAPI<ICountryStateByID>({
	actionType: countryStateType.getByID,
	url: '/api/v1/State',
});

export const getByCode = getFetchAPI<ICountryStateByID, { code: string }>({
	actionType: countryStateType.getByCode,
	url: '/api/v1/State/code',
});

export const getByName = getByNameAPI({
	actionType: countryStateType.getByName,
	url: '/api/v1/State/name',
});

export interface ICountryStateCreateUpdate {
	id?: number;
	name: string;
	stateCode: string;
	geographicalZoneId: number;
	wardCount: number;
	constituencyCount: number;
	pollingUnitCount: number;
	lgaCount: number;
}

export const update = updateAPI<undefined, ICountryStateCreateUpdate>({
	actionType: countryStateType.update,
	url: '/api/v1/State/update',
});

export const deleteById = deleteByIdAPI({
	actionType: countryStateType.deleteById,
	url: '/api/v1/State/delete',
});

export const updateMetaData = updateByIdAPI<undefined, IMetaDataFormHook>({
	actionType: countryStateType.updateMetaData,
	url: '/api/v1/State/updatemetadata',
});
